export default "__VITE_ASSET__fab56102__"